import { render, staticRenderFns } from "./DocumentosCard.vue?vue&type=template&id=e501014a"
import script from "./DocumentosCard.vue?vue&type=script&lang=js"
export * from "./DocumentosCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports